export default __webpack_public_path__ + "src/images/point2-026d5c.png";